var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranscodingSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n      }\n\n      .cls-1 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Transcoding Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.48,35.79a11.9,11.9,0,0,0,.45-1.31,10.7,10.7,0,0,0,.26-1.35l3.49-1.49a.71.71,0,0,0,.39-.83l-1.46-5.46a.7.7,0,0,0-.76-.51l-3.76.46a11,11,0,0,0-2-2l.46-3.75a.72.72,0,0,0-.53-.75l-5.46-1.46a.72.72,0,0,0-.83.39l-1.47,3.48a10.56,10.56,0,0,0-2.67.73l-3-2.28a.7.7,0,0,0-.91.07l-4,4a.71.71,0,0,0-.07.92l2.28,3A11.9,11.9,0,0,0,19.47,29a10.7,10.7,0,0,0-.26,1.35l-3.48,1.49a.71.71,0,0,0-.4.83l1.47,5.46a.69.69,0,0,0,.75.51l3.76-.46a10.64,10.64,0,0,0,2,2l-.45,3.75a.71.71,0,0,0,.52.75l5.46,1.46a.71.71,0,0,0,.82-.39l1.48-3.48a10.37,10.37,0,0,0,2.66-.73l3,2.28a.71.71,0,0,0,.91-.07l4-4a.73.73,0,0,0,.07-.92Zm-11.06.73a4.94,4.94,0,1,1,6-3.5A4.94,4.94,0,0,1,28.42,36.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.73,30.67a23,23,0,0,1,23-21.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.16 27.72 10.49 26.98 6.83 30.29 3.8 26.4 3.01 27.02 6.7 31.75 11.16 27.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.62,40.37a23,23,0,0,0,42,1.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.55 46.76 51.58 47.01 50.34 42.24 45.67 43.83 45.35 42.88 51.03 40.95 52.55 46.76"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.08,10.74a23,23,0,0,1,13.62,21"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.24 15.93 41.17 15.57 39.4 10.97 44.12 9.54 43.83 8.58 38.08 10.32 40.24 15.93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscodingSettings01);
export default __webpack_public_path__ + "static/media/Transcoding_Settings_01.8ca0786146efacffe0e9859dfbe1f226.svg";
export { ForwardRef as ReactComponent };